/**
 * Tiny shared copy helpers. Framework-free and dependency-free on purpose —
 * `qc/engine.ts` (statically imported by the batch Web Worker) is one consumer,
 * so nothing here may touch the DOM, React, or storage.
 */

/** "1 cue" / "42 cues" — naive English pluralization for status copy. */
export function plural(n: number, word: string): string {
  return `${n} ${word}${n === 1 ? '' : 's'}`;
}
